import * as React from 'react';
import styled from 'styled-components';
import { animated } from 'react-spring';

type NavButtonPosition = 'left' | 'right';

interface INavButton {
  style: any;
  position: NavButtonPosition;
  onClick: () => void;
}

export const NavButton: React.FC<INavButton> = ({
  style,
  position,
  onClick,
}) => {
  return (
    <StyledNavButton style={style} onClick={onClick} position={position}>
      <svg
        version="1.1"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="m24.773 98.543c-0.80078-0.80078-1.4531-1.5234-1.4531-1.6055s10.477-10.625 23.285-23.43c12.805-12.805 23.285-23.352 23.285-23.434s-10.477-10.629-23.285-23.434c-12.805-12.805-23.285-23.387-23.285-23.512 0-0.29297 2.8438-3.1328 3.1367-3.1328 0.12109 0 11.473 11.25 25.223 25l25 25-25 25c-13.75 13.75-25.102 25-25.227 25s-0.87891-0.65625-1.6797-1.457z"></path>
      </svg>
    </StyledNavButton>
  );
};

const StyledNavButton = styled(animated.div)<{ position: NavButtonPosition }>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({ position }) => (position === 'left' ? 0 : 'auto')};
  right: ${({ position }) => (position === 'right' ? 0 : 'auto')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  width: 54px;
  height: 54px;
  background: rgba(0, 0, 0, 0.9);
  z-index: 100;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    transform: ${({ position }) =>
      position === 'left' ? 'rotate(180deg)' : 'rotate(0deg)'};

    path {
      fill: white;
    }
  }

  &:hover {
    cursor: pointer;
    svg {
      path {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  @media all and (max-width: 900px) {
    width: 36px;
    height: 36px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
